// Valores de estilo vindos do documento. Só formatos fechados passam: nada de
// `url()`, `expression()`, `var()` ou `;` que abriria outra declaração.
const NUMBER = String.raw`(?:\d+(?:\.\d+)?|\.\d+)`
const ARG = `[+-]?${NUMBER}(?:%|deg)?`

const HEX = /^#(?:[0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/i
const COLOR_FUNCTION = new RegExp(String.raw`^(?:rgba?|hsla?)\(\s*${ARG}(?:(?:\s*[,/]\s*|\s+)${ARG}){2,3}\s*\)$`, 'i')
const COLOR_NAME = /^[a-z]+$/i
const FONT_SIZE = new RegExp(`^${NUMBER}(?:px|rem|em|%)$`, 'i')
const LINE_HEIGHT = new RegExp(`^${NUMBER}(?:px|rem|em|%)?$`, 'i')

// Nenhum valor válido passa disso; limitar antes do teste barra entradas enormes
const MAX_LENGTH = 64

const check = test => (value) => {
	if (typeof value !== 'string' || value.length > MAX_LENGTH) return null
	const clean = value.trim()
	return test(clean) ? clean : null
}

export const safeColor = check(value => HEX.test(value) || COLOR_FUNCTION.test(value) || COLOR_NAME.test(value))
export const safeFontSize = check(value => FONT_SIZE.test(value))
export const safeLineHeight = check(value => LINE_HEIGHT.test(value))
